export default __webpack_public_path__ + "static/media/denim.af4b3498.svg";